import axios from 'axios';
import { v7 } from 'uuid';

export const api_url = `${import.meta.env.VITE_APPLICATION_PATH}api`

export const api = axios.create({
    baseURL: `${import.meta.env.VITE_APPLICATION_PATH}api`,
    //baseURL: `http://localhost:39219/api`,
    //baseURL: 'https://app.auditaestoque.com.br/api'
});



api.interceptors.request.use(config => {
    if (localStorage.getItem('access_token')) {
        let access_token = localStorage.getItem('access_token');
        if (!config.params) {
            config.params = {};
        }
        config.params.access_token = access_token;
    }
    let params = {
        ...config.params,
        request_id: v7()
    }
    return {
        ...config,
        params
    };
}, err => {
    
    return Promise.reject(err);
})




export default api;